<div class="modal-header blue">
  <h4 class="modal-title">
    {{ user ? 'Edit User' : 'Create New User' }}
  </h4>
  <a href="javascript:void(0)" (click)="close()" class="modal-close-btn"></a>
</div>

<user-form [editableUser]="user" (submitEvent)="close(true)"> </user-form>
